// ./src/pages/privates/Services/index.tsx
import React from 'react';

import { IoCar } from 'react-icons/io5';

import { Options } from '@components/cards/CardHorizontalButtonNavigate/styles';
import {
  CardSimpleEstimate,
  HeaderNavigationPrivate,
  MenuSideBarPrivate,
  SubtitleSecondary,
} from '@components/index';
import { ConfigRoutes, ConfigStyles } from '@config/index';
import { Estimates } from '@pages/private/User/styles';

import { Container, ContainerGroup, Content } from './styles';

const Service: React.FC = () => {
  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">Serviços</SubtitleSecondary>
          <Estimates>
            <Options style={{ flexDirection: 'column', gap: '1rem' }}>
              <CardSimpleEstimate
                icon={IoCar}
                iconColor={ConfigStyles.rebox.colors.greenEmerald.main}
                iconSize={28}
                iconOpacity={0.8}
                label={`Adicione um modelo veicular`}
                linkName={`Adicione um modelo`}
                route={
                  ConfigRoutes.rebox.privates.tools.next.services.next.add_car
                    .path
                }
              />
              <CardSimpleEstimate
                icon={IoCar}
                iconColor={ConfigStyles.rebox.colors.red.main}
                iconSize={28}
                iconOpacity={0.8}
                label={`Remova um modelo veicular`}
                linkName={`Remova um modelo`}
                route={
                  ConfigRoutes.rebox.privates.tools.next.services.next
                    .remove_car.path
                }
              />
            </Options>
          </Estimates>
        </Content>
      </ContainerGroup>
    </Container>
  );
};

export default Service;
